import { useMemo } from 'react';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { MaximumTileTextLength } from '../atom.tile/context.js';
import { FacitContainer } from './containers/container.facit.js';
import { InputContainer } from './containers/container.input.js';
import { jsx } from 'react/jsx-runtime';

function PlaceItemsOnImageTask(props) {
  const context = useTaskContext();
  const pageContext = usePageContext();
  const maximumTileTextLength = useMemo(() => props.task.tiles.reduce((acc, curr) => {
    switch (curr.type) {
      case "Audio":
        return Math.max(acc, curr.title.length);
      case "Image":
        return Math.max(acc, curr.title.length);
      case "Text":
        return Math.max(acc, curr.text.length);
    }
  }, 0), [props.task.tiles]);
  const content = (() => {
    if (context === "input" && pageContext !== "print") {
      return /*#__PURE__*/jsx(InputContainer, {
        ...props
      });
    } else {
      return /*#__PURE__*/jsx(FacitContainer, {
        ...props
      });
    }
  })();
  return /*#__PURE__*/jsx(MaximumTileTextLength.Provider, {
    value: maximumTileTextLength,
    children: content
  });
}

export { PlaceItemsOnImageTask };
//# sourceMappingURL=_task.on-image.js.map
